import { useCallback, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx, getTransactionDetailsFromFlowConfig } from "utils";
import { getTransactionMethods } from "./";

export default function useGetTransactionMethods(defaultParams = null, queryOptions = {}) {
  const { sessionJWT } = useSessionJWT();
  const { sessionCtx } = useSessionCtx();
  const { flowConfig } = sessionCtx;

  // Pass on additional parameters to transaction methods endpoint
  const params = useMemo(() => {
    let extraParams = {};
    if (defaultParams) {
      extraParams = defaultParams;
    } else {
      extraParams = getTransactionDetailsFromFlowConfig(flowConfig);
    }
    if (extraParams && "transaction_amount" in extraParams) {
      // removing transaction_amount so PMs aren't filtered based on amount.  We can still show those to the user disabled with appropriate messaging
      delete extraParams["transaction_amount"];
    }
    return { ...(extraParams || {}) };
  }, [flowConfig, defaultParams]);

  const fetchTransactionMethods = useCallback(
    () => getTransactionMethods(sessionJWT, params),
    [sessionJWT, params]
  );

  return useQuery({
    queryKey: ["transaction-methods"],
    queryFn: fetchTransactionMethods,
    ...queryOptions
  });
}
